import script from "./PlatformAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./PlatformAnnouncements.vue?vue&type=style&index=0&id=656f6d25&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enpzjpl/zjpl-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656f6d25"]])

export default __exports__